import { Alert, Button, Divider, Group, Stack, Text } from "@mantine/core";
import { IconAlertTriangle } from "@tabler/icons-react";
import React from "react";
import FileUploadCard from "@/components/admin/FileUploadCard";
import PageHeader from "@/components/admin/header/PageHeader";
import { FileDropzoneButton } from "@/components/admin/vocUpload/FileDropzoneButton";
import { ONCE_TIME_UPLOAD_MAX_FILES } from "@/configs/constants/app/voc-data-management";
import useFileUpload from "@/hooks/useFileUpload";

const VoCFileUploadPage: React.FC = () => {
  const {
    acceptedFiles,
    remainingFiles,
    errorMessages,
    fileStatus,
    isAllFilesUploaded,
    isUploading,
    handleAcceptedFiles,
    handleRejectedFiles,
    handleDeleteSelectedFile,
    handleUpload,
    handleResetUploaded,
    clearErrorMessage,
  } = useFileUpload();

  return (
    <>
      <PageHeader title="データアップロード" />
      <Stack gap="md">
        <FileDropzoneButton
          onAcceptedFiles={handleAcceptedFiles}
          onRejectedFiles={handleRejectedFiles}
          maxFiles={remainingFiles}
        />

        {errorMessages.map((message, index) => (
          <Alert
            key={message}
            color="red"
            icon={<IconAlertTriangle />}
            onClose={() => clearErrorMessage(index)}
            withCloseButton
          >
            {message}
          </Alert>
        ))}

        <Stack align="stretch" justify="center" gap="xs">
          <Divider
            my="xs"
            label={<Text size="lg">選択されたファイル</Text>}
            labelPosition="left"
          />
          {/* ONCE_TIME_UPLOAD_MAX_FILES分の枠を表示 */}
          {Array.from({ length: ONCE_TIME_UPLOAD_MAX_FILES }, (_, index) => (
            <FileUploadCard
              key={index}
              file={acceptedFiles[index] ?? null}
              status={fileStatus[index]}
              onDelete={() => handleDeleteSelectedFile(index)}
            />
          ))}
        </Stack>

        <Group pt={3} justify="flex-end">
          {isAllFilesUploaded
            ? (
              <Button size="md" style={{ width: "18rem" }} onClick={handleResetUploaded}>
                リセットして続けてアップロード
              </Button>
            )
            : (
              <Button
                size="md"
                style={{ width: "18rem" }}
                onClick={handleUpload}
                loading={isUploading}
                loaderProps={{ type: "dots" }}
                disabled={acceptedFiles.length === 0}
              >
                アップロード開始
              </Button>
            )}
        </Group>
      </Stack>
    </>
  );
};

export default VoCFileUploadPage;
